import { IWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { useCallback, useState } from 'react'
import SidePage from '@/shared/SidePage'
import UpdateLineChartWidgetContent from '@/pages/Dashboards/components/UpdateWidgetSidePage/UpdateLineChartWidgetContent'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'
import { ILineChartSettings } from '@/pages/Dashboards/Charts/LineChart/lineChart.types.ts'
import UpdateSvgChartWidgetContent from '@/pages/Dashboards/components/UpdateWidgetSidePage/UpdateSvgChartWidgetContent'
import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import UpdateTextWidgetContent from './UpdateTextWidgetContent'
import { ITextWidgetSettings } from '../../Charts/TextChart/textChart.types'
import UpdateTableChartWidgetContent from '@/pages/Dashboards/components/UpdateWidgetSidePage/UpdateTableChartWidgetContent'
import { ITableChartSettings } from '@/pages/Dashboards/Charts/TableChart/tableChart.types.ts'

interface IProps {
  open: boolean
  onClose: () => void
  widget: IWidget
}

const UpdateWidgetSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [widget, setWidget] = useState(props.widget)

  const handleSettingsChange = useCallback(
    (settings: ILineChartSettings | ISVGSettings | ITextWidgetSettings | ITableChartSettings) => {
      // @ts-ignore
      setWidget((prev) => ({ ...prev, configuration: { ...prev.configuration, settings } }))
    },
    []
  )

  const renderContent = () => {
    switch (widget.type) {
      case 'linear':
        return <UpdateLineChartWidgetContent widget={widget} onChange={handleSettingsChange} />
      case 'text':
        return <UpdateTextWidgetContent widget={widget} onChange={handleSettingsChange} />
      case 'svg':
        return <UpdateSvgChartWidgetContent widget={widget} onChange={handleSettingsChange} />
      case 'table':
        return <UpdateTableChartWidgetContent widget={widget} onChange={handleSettingsChange} />
    }
  }

  const handleSave = () => {
    wait(dashboardsApi.updateWidget(props.widget.id, widget), (resp) => {
      if (resp.status === 'success') {
        dashboardsEvents.widgetUpdated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} size={props.widget.type === 'svg' ? 'large' : 'default'}>
      <div className="flex-lines height100 gap16">
        {renderContent()}
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" onClick={props.onClose} text="Отмена" disabled={loading} />
          <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.widget) return null

  return <UpdateWidgetSidePage {...props} />
}
